import { useReactFlow, useViewport } from '@xyflow/react'
import { IconButton, Typography } from 'shared/ui'

export const ZoomControls = () => {
  const { zoom } = useViewport()
  const { zoomTo } = useReactFlow()
  const zoomPercent = Math.round(zoom * 100)

  const restPercent = zoomPercent % 5
  const nextZoomOut = (zoomPercent - (restPercent || 5)) / 100
  const nextZoomIn = (zoomPercent + (5 - restPercent)) / 100

  return (
    <>
      <IconButton
        onClick={() => zoomTo(nextZoomOut)}
        ariaLabel={'zoomOut'}
        icon={'oneLine'}
        color={'tertiary'}
        variant={'icon'}
        tooltipProps={{
          placement: 'top',
          label: 'Zoom out',
        }}
      />
      <Typography ariaLabel={'zoom'} variant={'text-input-field-r'}>
        {zoomPercent}%
      </Typography>
      <IconButton
        onClick={() => zoomTo(nextZoomIn)}
        ariaLabel={'zoomIn'}
        icon={'add'}
        color={'tertiary'}
        variant={'icon'}
        tooltipProps={{
          placement: 'top',
          label: 'Zoom in',
        }}
      />
    </>
  )
}
